import React from 'react';
import { FieldAnswer, SelectChoiceField } from '@app/api';
import { useFormikContext } from 'formik';

import { Autocomplete } from '../Autocomplete';
import { MultipleChoiceChoice } from './MultipleChoiceChoice';
import { ChoicesLabel } from './ChoicesLabel';

interface Props {
  field: SelectChoiceField;
}

export const MultipleChoice = ({ field }: Props) => {
  const choices =
    field.properties && field.properties.choices
      ? field.properties.choices
      : [];

  const { values, setFieldValue } = useFormikContext<FieldAnswer>();

  if (field.properties.autocomplete) {
    return <Autocomplete field={field} />;
  }

  return (
    <>
      <ChoicesLabel field={field} />
      {choices.map((choice, index) => (
        <MultipleChoiceChoice
          key={`choice-${choice.ref}-${index}`}
          choice={choice}
          index={index}
          choices={values.choices}
          setFieldValue={setFieldValue}
        />
      ))}
    </>
  );
};
